/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Flex,
	Text,
	Textarea,
	useDisclosure,
} from '@chakra-ui/react';
import { useBranchChangeRequest } from '../../../../contexts/branch-change-request';
import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import useStore from '../../../../store';
import c from '../../../../constant';

const M_SUBMIT_APPROVAL = gql`
	mutation submit($id: String!, $status: BranchChangeCandidateStatus, $statusDescription: String) {
		submitBranchChangeCandidateApproval(id: $id, status: $status, statusDescription: $statusDescription)
	}
`;

let status = null;
let statusDescription = null;

export default function BranchChangeRequestCandidateApproval({ id = null, requestStatus = null }) {
	const { t } = useTranslation();
	const { loadedData, setLoadedData } = useBranchChangeRequest();
	const { currentUser: user } = useStore((state) => state.currentUser);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [reason, setReason] = useState('');
	const [submitApproval, { loading, data }] = useMutation(M_SUBMIT_APPROVAL);

	console.log(loadedData);

	useEffect(() => {
		if (data?.submitBranchChangeCandidateApproval) {
			onClose();
			setLoadedData({
				...loadedData,
				candidates: loadedData?.candidates?.map((e) => {
					if (e?.id === id) {
						e.status = status?.toUpperCase();
						e.statusDescription = statusDescription;
					}
					return e;
				}),
			});
		}
	}, [data]);

	return (
		<>
			<Flex>
				<Button
					colorScheme="green"
					variant="solid"
					size="md"
					h="28px"
					w="76px"
					fontSize="sm"
					fontWeight="normal"
					mr={1}
					borderRadius={c.borderRadius}
					isLoading={loading}
					isDisabled={requestStatus === 1 && c.stepOfficeRoles.includes(user?.position) ? false : true}
					onClick={() => {
						status = 'Approved';
						statusDescription = null;
						const variables = { id, status, statusDescription };
						submitApproval({ variables });
					}}
				>
					{t('approve')}
				</Button>
				<Button
					colorScheme="red"
					variant="solid"
					size="md"
					h="28px"
					w="76px"
					fontSize="sm"
					fontWeight="normal"
					ml={1}
					borderRadius={c.borderRadius}
					isLoading={loading}
					isDisabled={requestStatus === 1 && c.stepOfficeRoles.includes(user?.position) ? false : true}
					onClick={onOpen}
				>
					{t('Reject')}
				</Button>
			</Flex>
			<AlertDialog closeOnEsc={false} closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{t('Reject')}
						</AlertDialogHeader>
						<AlertDialogBody>
							<Text>
								{t('Please input rejection reason')}
								<span style={{ color: 'red' }}>*</span>
							</Text>
							<Textarea mt={2} value={reason} onChange={(e) => setReason(e.target.value ?? '')} />
						</AlertDialogBody>
						<AlertDialogFooter>
							<Button mr={4} isLoading={loading} onClick={onClose}>
								{t('Cancel')}
							</Button>
							<Button
								isLoading={loading}
								colorScheme="red"
								disabled={reason ? false : true}
								onClick={() => {
									status = 'Rejected';
									statusDescription = reason;
									const variables = { id, status, statusDescription };
									submitApproval({ variables });
								}}
							>
								{t('Reject')}
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
}
